import { render, staticRenderFns } from "./process-payroll.vue?vue&type=template&id=22da0030"
import script from "./process-payroll.vue?vue&type=script&lang=js"
export * from "./process-payroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports